import { Modal, Image } from "antd";

// eslint-disable-next-line import/namespace


const ModalImage = (props) => {
  const { isOpen, setIsOpen, extra } = props;

  if (!extra) {
    return null;
  }

  const modalWidth = 400 * extra.length;
  
  return (
    <>
      {typeof extra === "string" && (
        <Modal
          open={isOpen}
          footer={null}
          width={400}
          onCancel={() => setIsOpen(false)}
          closable={false}
        >
            {
                extra.includes('https://')
                &&
                <Image
                    width={300}
                    src={extra}
                    preview={false}
                />
                ||
                <div>{extra}</div>
            }
        </Modal>
      )}
      {Array.isArray(extra) && extra.length > 0 && (
        <Modal
          open={isOpen}
          footer={null}
          width={modalWidth}
          onCancel={() => setIsOpen(false)}
          closable={true}
          styles={{
              body: {
                  borderRadius: 5,
                  padding: '.3em 2em 2em 2em',
                  textAlign: 'center'
              },

          }}
        >
          <Image.PreviewGroup style={{display: "flex", alignItems: "center", marginRight: "10px"}}>
            {extra.map((item, index) => (
                    !((typeof item === 'string' && item.includes('.avi')) || (typeof item === 'string' && item.includes('.mp4')))
                    &&
                  <Image
                    key={index}
                    width={250}
                    height={250}
                    src={item.url || item}
                  />
            ))}
          </Image.PreviewGroup>
        </Modal>
      )} 
    </>
  );
};

export default ModalImage;
